import React, { useState } from 'react';
import styles from '../styles/FilterSection.module.css';

const FilterSection = () => {
  const [activeType, setActiveType] = useState('全部');
  const [activeDuration, setActiveDuration] = useState(null);

  return (
    <section className={styles.filterSection}>
      <div className={styles.container}>
        <div className={styles.filterContainer}>
          <div>
            <span className={styles.filterLabel}>账户类型：</span>
            {['全部', '高级账户', '基础账户', '企业账户'].map(type => (
              <span
                key={type}
                className={`${styles.filterTag} ${activeType === type ? styles.active : ''}`}
                onClick={() => setActiveType(type)}
              >
                {type}
              </span>
            ))}
          </div>
          <div>
            <span className={styles.filterLabel}>使用时长：</span>
            {['1个月', '3个月', '12个月'].map(duration => (
              <span
                key={duration}
                className={`${styles.filterTag} ${activeDuration === duration ? styles.active : ''}`}
                onClick={() => setActiveDuration(duration)}
              >
                {duration}
              </span>
            ))}
          </div>
          <div className={styles.searchBar}>
            <i className="fas fa-search"></i>
            <input type="text" placeholder="搜索镜像账户..." />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FilterSection;